import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { formatDate } from '@utils';
import { Paragraph, Subtitle } from '@components/Styled';
import { Notification as NotificationContainer } from '../NotificationCenter.style';
const SalesOrder = (props) => {
    const { notification } = props;
    const { dateToSpanish } = formatDate();
    const property = notification.params?.property;
    const validDaysOfBricksOnSale = notification.params?.validDaysOfBricksOnSale;
    const expirationDate = notification.params?.expirationDate;
    const propertyName = property?.name || '----';
    const brickText = notification.params?.numberOfBricks === 1
        ? 'Ladrillo'
        : 'Ladrillos';
    return (_jsxs(NotificationContainer, { children: [_jsxs(Subtitle, { level: "3", children: ["Has puesto a la venta", ` ${notification.params?.numberOfBricks} ${brickText} `, "en", ` ${propertyName}`] }), _jsx(Paragraph, { children: `Tu oferta de ${brickText} estará activa hasta el
        ${dateToSpanish(new Date(expirationDate))}.` }), _jsx(Paragraph, { children: `Si se vende, te notificaremos con todos los detalles de la transacción. Si no se vende
        en este plazo de ${validDaysOfBricksOnSale} días, la oferta caducará, pero
        siempre podrás crear una nueva si así lo deseas.` }), _jsx(Paragraph, { color: "grayF", children: notification.getLocaleDate() })] }));
};
export default SalesOrder;
